import { useQuery, useMutation } from "@tanstack/react-query";
import React from "react";
import { useStore } from "../../../../helpers";
import { useParams } from "react-router";

type taskAssignPayload = {
  projectid: number;
  surveyid: number;
  tasks: {
    booth: object;
    userid: number;
    sample_size: number;
  }[];
};
const useUIFormFunctions = () => {
  const {
    apiRequestHandler,
    taskManagerStore: { setBulkAssignTaskList },
  } = useStore();
  const { projectid } = useParams();
  const {
    data: surveys,
    error,
    isLoading,
  } = useQuery({
    queryKey: ["fetchSurveys"],
    queryFn: async () => {
      const response = await apiRequestHandler(
        "/project/projectsandsurveys",
        {},
        "Something went wrong while fetching surveys"
      );
      return response.data;
    },

    select: (data) =>
      //@ts-ignore
      data?.filter((item) => item.projectid === parseInt(projectid)) || [],
  });
  const { mutateAsync: assignTasks } = useMutation({
    mutationKey: ["assignTasks"],
    mutationFn: async (payload: taskAssignPayload) =>
      await apiRequestHandler(
        "/tfv2/task_creation",
        payload,
        "Something went wrong while assigning tasks"
      ),
  });
  const onSubmit = async (data) => {
    console.log("Assign Tasks Data");
    console.log(data);
    const payload: taskAssignPayload = {
      projectid: parseInt(projectid),
      surveyid: data.survey?.surveyid,
      tasks: data.tasks.map((task) => ({
        booth: task.booth,
        userid: task.phone?.id,
        sample_size: task.sample_size,
      })),
    };

    await assignTasks(payload);
    setBulkAssignTaskList([]);
  };
  const onError = (error) => {
    console.log("Assign Tasks error");
    console.log(error);
  };
  return { surveys, error, isLoading, onSubmit, onError };
};

export default useUIFormFunctions;
